module.exports = __webpack_public_path__ + "static/mask-shl21-cde29711e5829fb42d7892d7f868011f.svg";